import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import './LocationPage.css'
import AftersalesSupportSection from "../../components/sections/AftersalesSupportSection/AftersalesSupportSection";
import RiyadhShowroomBanner from "../../assets/images/riyadh-showroom.jpg"
import { CalendarClock, MapPin, PhoneCall } from "lucide-react";

export default function LocationPage() {



    return (
        <div className="Page">
            <div className="locationPageBanner text-center">
                <div className="page-banner-content">
                    <h3>
                        Our Locations
                    </h3>
                    <h1>
                        Available to Serve You Better
                    </h1>
                </div>
            </div>

            <Container fluid>
                <div className="section-spacing">
                    <p class="brand-section-desc text-center mb-0">Sales, Service & Parts Under One Roof</p>
                </div>

                <Row>
                    <Col md={5}>
                        <div className="showroom-pic">
                            <img src={RiyadhShowroomBanner} />
                        </div>

                    </Col>

                    <Col md={7}>
                        <div className="location-details">
                            <h3>Riyadh Showroom</h3>
                        </div>
                        <Row>
                            <Col md={6}>
                                <div className="location-details">
                                    <div className="location-data text-center mt-4">
                                        <div className="location-icon-holder mb-2">
                                            <PhoneCall />
                                        </div>

                                        <div className="location-subdata">
                                            <h5>Contact Number</h5>
                                            <a href="#" tel="8001240664">8001240664</a>
                                        </div>
                                    </div>

                                </div>
                            </Col>

                            <Col md={6}>
                                <div className="location-data text-center mt-4">
                                    <div className="location-icon-holder mb-2">
                                        <MapPin />
                                    </div>

                                    <div className="location-subdata">
                                        <h5>Address</h5>
                                        <a href="https://maps.app.goo.gl/nFcCguNArbaEVaST8?g_st=iw" target="_blank">Eastern Ring Road Exit 18, Riyadh</a>
                                    </div>
                                </div>
                            </Col>

                            <Col md={12}>
                                <div className="location-data text-center mt-4">
                                    <div className="location-icon-holder mb-2">
                                        <CalendarClock />
                                    </div>

                                    <div className="location-subdata">
                                        <h5>Opening Hours</h5>
                                        <p>Sunday to Thursday</p>
                                        <p>9:00am - 5:00pm</p>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                    </Col>
                </Row>

                <div className="location-map">
                    {/* <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3626.573316043473!2d46.79624487536374!3d24.638386878074865!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDM4JzE4LjIiTiA0NsKwNDcnNTUuOCJF!5e0!3m2!1sen!2ssa!4v1767806738944!5m2!1sen!2ssa" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}

                    <iframe
                        title="LandKing Riyadh Showroom Location"
                        src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3626.573316043473!2d46.79624487536374!3d24.638386878074865!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjTCsDM4JzE4LjIiTiA0NsKwNDcnNTUuOCJF!5e0!3m2!1sen!2ssa!4v1767806738944!5m2!1sen!2ssa"
                        width="100%"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </div>
            </Container>

            <div className="section-spacing-top">
                <AftersalesSupportSection />
            </div>
        </div>
    );
}